export default __webpack_public_path__ + "static/media/events2.4a500305.jpeg";